<template>
<v-dialog
    v-model="dialog"
    max-width="600"
    v-if="qr_code != null"
>
    <v-card>
        <v-card-title>Setup Google Authenticator</v-card-title>

        <v-card-text>
            <p>Use the QR code to add RedChirp to Google Authenticator</p>

            <div
                style="text-align: center"
            >
                <img :src="qr_code.image_url"/>
            </div>

            <p>Alternatively, you can add manually using the secret</p>
            <p><code>{{secret}}</code></p>

            <p>Then enter the one time password (six digit code) produced.  This is used to confirm that your authenticator is properly configured</p>

            <v-text-field
                label="Enter one time password"
                v-model="otp"
                autofocus
                v-on:input="onChangeOTP"
                autocomplete="off"
            />

            <div
                v-if="$rc.$state.isSystemAdmin()"
                style="margin-top: 16px;"
            >
                <m-restricted-button
                    v-on:click="otp = 'skip'; onChangeOTP();"
                    small
                   
                >
                    Skip this step
                </m-restricted-button>
            </div>

        </v-card-text>

        <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
                text
                @click="onCancel"
            >
            Cancel
            </v-btn>

            <v-btn
                color="primary darken-1"
                text
                @click="onOk"
                :disabled="!is_valid"
            >
            Enable
            </v-btn>

        </v-card-actions>

    </v-card>
</v-dialog>
</template>

<script>

export default {

    data() {
        return {
            employee_id: null,
            qr_code: null,
            secret: null,
            dialog: false,
            otp: null,

            is_valid: false,
        }
    },

    methods: {

        showDialog(employee_id)
        {
            this.employee_id = employee_id;
            this.otp = null;
            this.is_valid = false;

            this.$rc.showSpinner();


            this.$rc.rest(
                'PUT: /api/v1/auth/2fa/totp/generate',

                {
                    'employee_id': this.employee_id
                },

                (data) => {
                    this.$rc.hideSpinner();

                    this.qr_code = data.qr_code;
                    this.secret = data.secret;
                },

                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to create google authenticator QR code');
                },
            );

            this.dialog = true;
        },

        onOk()
        {
            this.$rc.showSpinner();

            this.$rc.rest(
                'PUT: /api/v1/auth/2fa/totp/enable',

                {
                    'employee_id': this.employee_id,
                    'qr_code_id': this.qr_code.qr_code_id,
                    'otp' : this.otp
                },

                (data) => {
                    this.dialog = false;
                    this.$emit('reload-profile');
                },

                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to enable two factor authentication');
                },
            );
        },

        onCancel()
        {
            this.dialog = false;
            this.$emit('reload-profile');
        },

        onChangeOTP()
        {
            this.$rc.rest(
                'PUT: /api/v1/auth/2fa/totp/could-enable',

                {
                    'employee_id': this.employee_id,
                    'qr_code_id': this.qr_code.qr_code_id,
                    'otp' : this.otp
                },


                (data) => {
                    this.is_valid = data.success;
                },

                () => {
                    this.is_valid = false;
                },
            );
        },

    },
}
</script>

<style lang="scss" scoped>
</style>